import * as React from 'react';
import Item from './Field';
import useForm from './hooks/useForm';
import FieldForm from './Form';
import { FormProvider } from './FormContext';
var InternalForm = /*#__PURE__*/React.forwardRef(FieldForm);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Item = Item;
RefForm.Item.displayName = 'Item';
RefForm.useForm = useForm;
RefForm.displayName = 'Form';
export { Item, FormProvider };
export default RefForm;